import * as React from 'react'
import {ReactNode} from 'react'
import {Nullable} from '../../../../../app/TypeHelpers'
import {LeftRowFlexContainer} from '../../../../../styledComponents/FlexComponents'
import { Box, FormLabel, InputAdornment } from '@mui/material';
import PPNumericField from '../../../../shared/forms/PPNumericField'
import {HKConstants} from '../../../../../HKConstants'
import {numberOrNull, stringOrEmpty} from '../../../../../stringHelper/stringHelpers'
import {RESERVATION_TIME_UNIT_MINUTES_NOT0, UNIT_TIME} from '../../../../../CodeMaster'
import PPSelect from '../../../../shared/forms/PPSelect'
import {addEmptyData} from '../../../../../componentHelper/selectHelper'
import PPCheckboxGroup from '../../../../shared/forms/PPCheckboxGroup'
import {Messages} from '../../../../../Messages'
import styled from 'styled-components'
import {SelectChangeEvent} from '@mui/material/Select'

export interface BusinessScheduleCharge {
    charge: Nullable<number>,
    chargeUnit: UNIT_TIME,
    chargeUnitTime: Nullable<number>,
    fixedCharge: boolean
}

interface Props {
    businessScheduleCharge: BusinessScheduleCharge
    disabled: boolean
    showHint: boolean
    businessSchedulePattern: string
    dayOfWeek: string
    handleBusinessScheduleChargeChanged: (businessScheduleCharge: BusinessScheduleCharge) => void
}

class BusinessScheduleChargeComponent extends React.Component<Props> {

    static displayName: string = 'BusinessScheduleChargeComponent'

    constructor(props: Readonly<Props>) {
        super(props)

        this.handleChargeUnitChange = this.handleChargeUnitChange.bind(this)
        this.handleFixedChargeChange = this.handleFixedChargeChange.bind(this)
    }

    handleNumericValueChange = (target: string) =>
        (event: React.ChangeEvent<{ value: unknown }> | SelectChangeEvent<unknown>) => {
        const numericValue: Nullable<number> = numberOrNull(`${event.target.value}`)
        this.props.handleBusinessScheduleChargeChanged({
            ...this.props.businessScheduleCharge,
            [target]: numericValue,
        })
    }

    handleChargeUnitChange(event: SelectChangeEvent<unknown>): void {
        this.props.handleBusinessScheduleChargeChanged({
            ...this.props.businessScheduleCharge,
            chargeUnit: UNIT_TIME.codeToEnumConstants(`${event.target.value}`),
            chargeUnitTime: null,
        })
    }

    handleFixedChargeChange(label: string, checked: boolean): void {
        this.props.handleBusinessScheduleChargeChanged({
            ...this.props.businessScheduleCharge,
            fixedCharge: checked,
        })
    }

    render(): ReactNode {
        const {businessScheduleCharge} = this.props

        return (<>
            <Box>
                <LeftRowFlexContainer>
                    <label>
                        <ChargePerUnitInput
                            InputProps={{
                                inputProps: {
                                    min: 0,
                                    max: HKConstants.VMN.FAC.MAX_PRICE,
                                },
                                endAdornment: <InputAdornment position="end">円</InputAdornment>,
                            }}
                            value={stringOrEmpty((businessScheduleCharge.charge))}
                            disabled={this.props.disabled}
                            onChange={this.handleNumericValueChange('charge')}
                        />
                    </label>
                    <FormLabel disabled={businessScheduleCharge.fixedCharge || this.props.disabled}>
                        <LeftRowFlexContainer>
                            /
                            {
                                businessScheduleCharge.chargeUnit === UNIT_TIME.MINUTES &&
                                <MinutesSelect
                                    data={addEmptyData(RESERVATION_TIME_UNIT_MINUTES_NOT0.values())}
                                    value={stringOrEmpty(businessScheduleCharge.chargeUnitTime)}
                                    onChange={this.handleNumericValueChange('chargeUnitTime')}
                                    disabled={businessScheduleCharge.fixedCharge || this.props.disabled}
                                />
                            }
                            {
                                businessScheduleCharge.chargeUnit === UNIT_TIME.HOUR &&
                                <HoursInput
                                    InputProps={{
                                        inputProps: {
                                            min: 1,
                                            max: HKConstants.VMN.FAC
                                                .MAX_PRICE_UNIT_TIME_HOUR_OF_BUSINESS_SCHEDULE,
                                        },
                                    }}
                                    value={stringOrEmpty(businessScheduleCharge.chargeUnitTime)}
                                    onChange={this.handleNumericValueChange('chargeUnitTime')}
                                    disabled={businessScheduleCharge.fixedCharge || this.props.disabled}
                                />
                            }
                        </LeftRowFlexContainer>
                    </FormLabel>
                    <Box marginLeft={'5px'}/>
                    <PPSelect
                        data={UNIT_TIME.values()}
                        value={businessScheduleCharge.chargeUnit.value}
                        onChange={this.handleChargeUnitChange}
                        disabled={businessScheduleCharge.fixedCharge || this.props.disabled}
                    />
                    <PPCheckboxGroup
                        data={[
                            {
                                label: '固定料金',
                                checked: businessScheduleCharge.fixedCharge,
                                checkboxProps: {
                                    disabled: this.props.disabled,
                                },
                            },
                        ]}
                        onChangeChecked={this.handleFixedChargeChange}
                        hint={this.props.showHint ? Messages.HFACA0007.message : undefined}
                    />
                </LeftRowFlexContainer>
            </Box>
        </>)
    }
}

const ChargePerUnitInput = styled(PPNumericField)`
  width: 110px;
`

const MinutesSelect = styled(PPSelect)`
  width: 60px;
`

const HoursInput = styled(PPNumericField)`
  width: 60px;
`

export default BusinessScheduleChargeComponent
